import { focusManager } from '@tanstack/react-query';
import { useEffect } from 'react';
import { AppState, Platform } from 'react-native';

export function useAppStateFocus() {
  useEffect(() => {
    // React Query already supports in web browser refetch on window focus by default
    if (Platform.OS === 'web') {
      return;
    }

    // Listen to app state changes
    const subscription = AppState.addEventListener('change', status => {
      focusManager.setFocused(status === 'active');
    });

    return () => subscription.remove();
  }, []);
}
